"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPerpetualBondOfferBonding = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const helpers_1 = require("../../../helpers");
const constants_1 = require("../../../constants");
const types_1 = require("../../../types");
const _1 = require(".");
const helpers_2 = require("./helpers");
const createPerpetualBondOfferBonding = (_a) => __awaiter(void 0, [_a], void 0, function* ({ programId, connection, args, accounts, sendTxn, }) {
    const program = (0, helpers_1.returnAnchorProgram)(connection);
    const instructions = [];
    const bondOfferSeed = Math.ceil(Math.random() * 1000000);
    const [bondOffer] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BOND_OFFER_PREFIX), accounts.userPubkey.toBuffer(), constants_1.ENCODER.encode(bondOfferSeed.toString())], program.programId);
    const lendingTokenType = (0, _1.getLendingTokenType)(args.bondingCurveType);
    const splTokenMint = (0, helpers_2.getTokenMintFromLendingTokenType)(lendingTokenType);
    const [lenderVault, lenderVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_1.USER_VAULT_PREFIX),
        accounts.userPubkey.toBuffer(),
        splTokenMint.toBuffer()
    ], program.programId);
    const [rentVault, rentVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([
        constants_1.ENCODER.encode(constants_1.RENT_VAULT),
    ], program.programId);
    const isSplFeature = args.bondFeature == types_1.BondFeatures.AutoReceiveAndReceiveSpl;
    instructions.push(yield program.methods
        .createPerpetualBondOfferBonding(new anchor_1.BN(bondOfferSeed), new anchor_1.BN(args.loanValue), new anchor_1.BN(args.quantityOfLoans), (0, helpers_1.createDecodeEnum)(args.bondingCurveType, {}), new anchor_1.BN(args.collateralsPerToken), new anchor_1.BN(args.tokenLendingApr), new anchor_1.BN(args.liquidationLtvBP ? args.liquidationLtvBP : 0), new anchor_1.BN(args.offerLtvBP ? args.offerLtvBP : 0))
        .accountsStrict({
        bondOfferV2: bondOffer,
        hadoMarket: accounts.hadoMarket,
        user: accounts.userPubkey,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        splTokenMint,
        lenderVault,
        rentVault,
    })
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [];
    yield sendTxn(transaction, signers);
    return {
        instructions,
        signers,
        accounts: {
            bondOffer: bondOffer,
            lenderVault: lenderVault
        },
    };
});
exports.createPerpetualBondOfferBonding = createPerpetualBondOfferBonding;
